import React from 'react';
import DynamicIcon from '../DynamicIcon';

/**
 * Componente per visualizzare stato di caricamento nella DataTable
 * 
 * @param {Object} props
 * @param {String} props.message - Messaggio da mostrare durante il caricamento
 */
const LoadingState = ({
    message = 'Caricamento dati...'
}) => {
    return (
        <div className="data-table-loading-state">
            <DynamicIcon iconClass="fa-solid fa-circle-notch fa-spin" />
            <p className="mt-2">{message}</p>
        </div>
    );
};

export default LoadingState;
